/**
 * 解决el-button按钮点击后不会自动失焦问题:
 * @example:
 *  <el-button v-fix-focus @click="handleClick">按钮</el-button>
 * */

export default {
    install: app => {
        const fun = function (evt) {
            let target = evt.target
            if (target.nodeName === 'SPAN') {
                target = evt.target.parentNode
            }
            target.blur()
        }
        app.directive('fix-focus', {
            mounted(el) {
                el.addEventListener('focus', fun)
            },
            unmounted(el) {
                el.removeEventListener('focus', fun)
            },
        })
    },
}
